{
  "#CLAIM_REPORT": {
    "TITLE": "Claim Report",
    "MAIN_PAGE_TITLE": "Claim Report – Main",
    "LOAD_FAILED": "Loading failed",
    "RETRY": "Try again",
    "CHANGE": "Change",
    "CUSTOMERS": {
      "TITLE": "Customers",
      "SEARCH_PLACEHOLDER": "Customer name, customer number, or document number",
      "SCAN_CONTRACT_BARCODE": "Scan rental agreement barcode",
      "SCAN_CUSTOMER_CARD": "Scan customer card",
      "SCAN_CONTRACT_NOT_FOUND": "Rental contract not found",
      "SCAN_CARD_INVALID": "Invalid customer card",
      "EMPTY": "No customers found",
      "OR": "Or"
    },
    "DOCUMENTS": {
      "TITLE": "Documents",
      "EMPTY": "No rental contracts found",
      "SELECTED_CUSTOMER_LABEL": "Customer"
    },
    "DEVICES": {
      "TITLE": "Devices",
      "SELECTED_DOCUMENT_LABEL": "Document",
      "EMPTY": "No devices in this rental contract",
      "CONTEXT_LABEL": "Device"
    },
    "DETAIL_EMPTY": {
      "TITLE": "No customer selected",
      "DESCRIPTION": "Select a customer on the left, or search directly by customer name, customer number, or contract number."
    },
    "COMPLAINT_FORM": {
      "STEP_ERFASSUNG": "Capture",
      "STEP_ABSCHLUSS": "Completion",
      "STEP_SIGNATURE": "Signature",
      "STEP_THIRD_PARTY": "Third Party",
      "STEP_VEHICLES": "Vehicles",
      "STEP_DAMAGE": "Damage",
      "STEP_VALUE": "Value",
      "SUBJECT": "Subject",
      "DATE": "Date",
      "DAMAGE_LOCATION": "Damage location",
      "INCIDENT_DESCRIPTION": "Description of the incident",
      "THIRD_PARTY_INVOLVED": "Were third parties or other vehicles involved?",
      "ACCIDENT_OPPONENTS_TITLE": "Accident opponent data",
      "ACCIDENT_OPPONENT_LABEL": "Accident opponent",
      "OPPONENT_TYPE_GENERAL": "General",
      "OPPONENT_TYPE_VEHICLE": "Vehicle",
      "OPPONENT_NAME": "Name",
      "OPPONENT_STREET": "Street",
      "OPPONENT_HOUSE_NUMBER": "House number",
      "OPPONENT_ZIP_CODE": "ZIP code",
      "OPPONENT_CITY": "City",
      "OPPONENT_PHONE": "Phone",
      "OPPONENT_EMAIL": "Email (optional)",
      "OPPONENT_EMAIL_INVALID": "Invalid email address",
      "OPPONENT_INSURANCE": "Insurance",
      "OPPONENT_INSURANCE_NUMBER": "Insurance number",
      "OPPONENT_LICENSE_PLATE": "Vehicle license plate",
      "OPPONENT_TRAILER_LICENSE_PLATE": "Trailer license plate (optional)",
      "LICENSE_PLATE_INVALID": "Invalid license plate",
      "OWN_VEHICLE_TITLE": "Own vehicle",
      "OWN_VEHICLE_DESCRIPTION": "Please provide details about your vehicle.",
      "OWN_VEHICLE_LICENSE_PLATE": "Own vehicle license plate",
      "OWN_TRAILER_TITLE": "Own trailer (optional)",
      "OWN_TRAILER_LICENSE_PLATE": "Trailer license plate",
      "OWN_VEHICLE_INSURANCE": "Insurance",
      "OWN_VEHICLE_INSURANCE_NUMBER": "Insurance Number",
      "ADD_ACCIDENT_OPPONENT": "Add another accident opponent",
      "REMOVE_ACCIDENT_OPPONENT": "Remove accident opponent",
      "POLICE_REPORT_TAKEN": "Was a police report taken?",
      "POLICE_STATION": "Police station",
      "POLICE_CASE_NUMBER": "Case number",
      "DETAILED_DAMAGE_DESCRIPTION": "Detailed damage description",
      "ESTIMATED_VALUE": "Estimated damage value",
      "TOTAL_LOSS": "Expected total loss?",
      "TOTAL_LOSS_YES": "Yes",
      "TOTAL_LOSS_NO": "No",
      "TOTAL_LOSS_AWAITING_REPORT": "Awaiting assessor's report",
      "DESIRED_HANDLING": "Desired handling",
      "DESIRED_HANDLING_INSURANCE_MP": "Insurance MP",
      "DESIRED_HANDLING_INSURANCE_MP_DESCRIPTION": "Direct settlement via our partner insurance",
      "DESIRED_HANDLING_INSURANCE_CUSTOMER": "Insurance customer",
      "DESIRED_HANDLING_INSURANCE_CUSTOMER_DESCRIPTION": "Independent claim settlement",
      "DESIRED_HANDLING_SELF_PAYER": "Self-payer",
      "DESIRED_HANDLING_SELF_PAYER_DESCRIPTION": "Settlement of repair costs at your own expense",
      "CANCEL": "Cancel",
      "NEXT": "Next",
      "SUBMIT": "Complete report",
      "BACK": "Back",
      "SUMMARY_TITLE": "Summary",
      "SUMMARY_DESCRIPTION": "Please review the entered data. Use \"Back\" to correct any details.",
      "CONTEXT_SECTION": "Rental Agreement & Device",
      "CUSTOMER": "Customer",
      "DOCUMENT": "Document",
      "DEVICE": "Device",
      "ARTICLE_NUMBER": "Article number",
      "DAMAGE_SECTION": "Damage data",
      "DETECTED_DAMAGE_SECTION": "Detected damage",
      "DAMAGE_DETAILS_SECTION": "Damage details",
      "SIGNATURES_TITLE": "Signatures",
      "SIGNATURES_DESCRIPTION": "Please provide the required signatures to complete the report.",
      "CASEWORKER_LABEL": "Case worker",
      "CUSTOMER_LABEL": "Customer",
      "CUSTOMER_SIGNER_NAME": "Customer name",
      "SIGN_HERE": "Sign here",
      "CLEAR_SIGNATURE": "Clear field",
      "UNDO_SIGNATURE": "Undo",
      "CONFIRMATION": "I confirm the accuracy of the information provided above and have read the terms and conditions.",
      "SEND_SECTION_TITLE": "Send",
      "SEND_SECTION_DESCRIPTION": "Who should receive the claim report?",
      "EMAIL_PLACEHOLDER": "name@company.com",
      "ADD_EMAIL": "Add email address",
      "REMOVE_EMAIL": "Remove email address",
      "EMAIL_INVALID": "Invalid email address",
      "MAIL_SUBJECT": "Your claim report",
      "MAIL_BODY": "Please find the claim report attached as a PDF.",
      "SUCCESS_TITLE": "Claim Report",
      "SUCCESS_SUBTITLE": "Claim report submitted successfully",
      "NEW_REPORT": "New Report",
      "DOWNLOAD_PDF": "Download PDF",
      "PDF_ERROR_TITLE": "PDF could not be generated",
      "PDF_ERROR_DESCRIPTION": "An error occurred while generating the PDF document. Please try again.",
      "PDF_ERROR_RETRY": "Retry"
    }
  }
}
